var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueBgBottomMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 385,
    height: 51.432,
    viewBox: "0 0 385 51.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19",
    d: "M564.273 3.13 508.979.853l-57.55.366-56.018 2.837-53.28-2.6L282.2.167l-57.15 2.859-52.98.741L114.428 0 56.257 3.07 1.574 2.349 0 49.564l58.6.772 55.093-2.908 55.338 3.617 58.759-.818 56.134-2.77 53.256 1.124 58.417 2.851 57.93-2.995 53.393-.34 56.99 2.346 48.614-1.7V1.439z",
    transform: "rotate(180 306.26 25.716)",
    style: {
      fill: "#629A41"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBgBottomMobile);
export default __webpack_public_path__ + "static/media/blue-bg-bottom-mobile.7174aab3f5a93e2116a1b9221e56fd6a.svg";
export { ForwardRef as ReactComponent };